import { render, staticRenderFns } from "./v-switch.vue?vue&type=template&id=e38218fc&"
import script from "./v-switch.vue?vue&type=script&lang=js&"
export * from "./v-switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports